import React from "react";
import { useTranslation } from "react-i18next";
import { AutosaveCountdown } from "./AutosaveCountdown";

interface ManualBuilderHeaderProps {
  onSave: () => void;
  hasUnsavedChanges: boolean;
  lastChangeTimestamp: number;
}

export const ManualBuilderHeader: React.FC<ManualBuilderHeaderProps> = ({
  onSave,
  hasUnsavedChanges,
  lastChangeTimestamp,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-gray-900">
        <span className="px-2.5 py-1 text-xs font-bold text-white rounded-full bg-gradient-to-r from-cyan-800 via-cyan-600 to-cyan-300 flex items-center gap-1 w-fit">
          V2 (NEW)
        </span>
        {t("manual.screen.title")}{" "}
        <span className="inline text-sm pl-2 text-cyan-600 cursor-pointer">
          Wiki
        </span>
      </h1>
      <p className="text-sm text-gray-500 block pt-6 w-8/12">
        {t("manual.screen.subline")}
      </p>
      <div className="flex justify-end items-center gap-3 mb-4">
        {hasUnsavedChanges && (
          <div className="text-amber-600">
            <AutosaveCountdown
              key={lastChangeTimestamp}
              isActive={hasUnsavedChanges}
              duration={6000}
            />
          </div>
        )}
        <button
          onClick={onSave}
          type="button"
          className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:ml-3 disabled:opacity-50"
        >
          {t("manual.screen.save")}
        </button>
      </div>
    </div>
  );
};
